import { createClient } from "@supabase/supabase-js";

export const supabase = createClient(
  "https://pobobufclzbxpawqtxwx.supabase.co",
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBvYm9idWZjbHpieHBhd3F0eHd4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMwNjMyMDAsImV4cCI6MjA4ODYzOTIwMH0.nc97mZ-_WW3vZhIwMWtC5ILb3KGcq_dV6rxPZH2M1u0"
);
